/* Copyright (c) 2017 Backpack Health LLC */

const tokenTypes = {
  forgotPassword: 'forgot_password',
  changeEmail: 'change_email',
  verifyEmail: 'verify_email',
};

export default tokenTypes;
